<div class="button-container">
  @if (!croppingFile) {
    <glxy-image-uploader
      [maxFiles]="1"
      [accept]="acceptedFiles"
      [hintText]="hintText"
      (filesChanged)="onFilesChanged($event)"
      (fileUploadErrored)="onError($event)"
      [layout]="'button-only'"
      [buttonText]="convertButtonText(buttonText)"
      [maxFileSize]="1024 * 1024 * 5"
    />
  }
</div>
